class carEditCtrl {
    constructor($scope, $http, httpRequest, $state, formvalidateApi, $timeout,logger) {
        // 初始化表单数据
        $scope.isEdit = $state.params.goodId
        $scope.codeIsDisable = true
        // 车辆类别列表
        httpRequest.get_getLoginUserGoodsTypeList(1).then((res) => {
            $scope.vehicleTypeList = res.data.value
            $scope.goodsInfoForm.typeId = $scope.vehicleTypeList[0].typeId
        })
        httpRequest.get_dictByTypeArr(['is_privilege']).then((res) => {
            $scope.privilegeList = res.data.value.is_privilege
            $scope.privilegeList.forEach((i) => i.enumCode = +i.enumCode)
        })
        $scope.carTypeObj = {}
        $scope.fieldObj = {}
        $scope.manufacturerNameObj = {}
        // 继续新增按钮只在新增页面
        $scope.addContinueBtn = false
        // 初始化表单数据
        $scope.goodsInfoForm = {
            isPrivilege: '0',
            status: 1,
            taxRate: 0,
        }
        // 自动编码
        $scope.codeAutoSetting = function codeAutoSetting(val) {
            $scope.codeIsDisable = val
            if (val) {
                $scope.goodsInfoForm.code = null
            }
        }
        if ($state.current.name === 'outputManage.ovat.goodsInfo.addCar') {
            $scope.addContinueBtn = true
        }

        // 税分合并编码获取的数据
        $scope.taxClassInfo = {}
        $scope.changeCar = function (item, v) {
            if (v) {
                $scope.goodsInfoForm.place = item.name
            } else {
                $scope.goodsInfoForm.enterpriseName = item.name
            }
        }
        // 车辆类型选择后回调
        $scope.carCallback = function carCallback() {
            $timeout(() => {
                $scope.goodsInfoForm.vehicleType = $scope.carTypeObj.name

            })
        }

        // 获取商品税率
        function getTaxRateOptions() {
            const rateReq = {
                taxMergeCode: $scope.goodsInfoForm.taxMergeCode,
                privilegeType: encodeURIComponent($scope.goodsInfoForm.privilegeType || ''),
                invType: 12,
            }
            return httpRequest.get_qryGoodsInfoTax(rateReq).then((res) => {
                $scope.taxRateList = res.data.value
                // $scope.goodsInfoForm.taxRate = taxRate === 0 ? taxRate : taxRate || $scope.taxRateList[0]
            })
        }

        function setTaxRate() {
            if ($scope.goodsInfoForm.isPrivilege === 1) {
                $scope.goodsInfoForm.taxRate = $scope.taxRateList[0]
            } else {
                $scope.goodsInfoForm.taxRate = $scope.taxClassInfo.taxRateList[0]
            }
        }

        // 获取数据
        if ($scope.isEdit) {
            httpRequest.get_qryVehicleGoodInfo($scope.isEdit).then((res) => {
                $scope.goodsInfoForm = res.data.value
                // $scope.goodsInfoForm.isPrivilege += ''
                $timeout(() => {
                    $scope.carTypeObj.name = $scope.goodsInfoForm.vehicleType
                    $scope.fieldObj.name = $scope.goodsInfoForm.place
                    $scope.manufacturerNameObj.name = $scope.goodsInfoForm.enterpriseName
                })
                $http.get(`${host.etcloudOvat}settings/sysGoodsInfo/qryTaxClassInfo?taxMergeCode=${$scope.goodsInfoForm.taxMergeCode}`).then((res1) => {
                    $scope.taxClassInfo = res1.data.value
                    // $scope.goodsInfoForm.privilegeType = $scope.goodsInfoForm.isPrivilege == 0 ? '' : $scope.taxClassInfo.taxSpecialManageList[0]
                    getTaxRateOptions()
                })
            })
        }

        /**
         * 当商品享受不征税，且税率为0税率锁定
         * @param  {object}  taxClassInfo 税分编码信息
         */
        function isTaxClassLocked(taxClassInfo) {
            const {
                taxSpecialManageList
            } = taxClassInfo
            if (taxSpecialManageList.length === 1 &&
                taxSpecialManageList[0] === '不征税' &&
                taxClassInfo.taxRateList[0] === 0) {
                return true
            }
            return false
        }
        // 税收编码选择后回调
        $scope.qryTaxClassInfo = function qryTaxClassInfo() {
            $timeout(() => {
                if (!($scope.taxClassInfo.discountOptionList && $scope.taxClassInfo.discountOptionList.length < 2)) {
                    $scope.goodsInfoForm.isPrivilege = 0
                    $scope.goodsInfoForm.privilegeType = ''
                } else {
                    $scope.goodsInfoForm.isPrivilege = 1
                    $scope.goodsInfoForm.privilegeType = $scope.taxClassInfo.taxSpecialManageList[0]
                }
                $scope.goodsInfoForm.taxClassName = $scope.taxClassInfo.taxName
                $scope.goodsInfoForm.codeVersions = $scope.taxClassInfo.codeVersions
                $scope.goodsInfoForm.taxMergeCode = $scope.taxClassInfo.mergeCode
                $scope.goodsInfoForm.taxRate = $scope.taxClassInfo.taxRateList[0]
                $scope.goodsInfoForm.taxShortName = $scope.taxClassInfo.taxShortName
                $scope.isTaxClassLocked = isTaxClassLocked($scope.taxClassInfo)
                // 强制不征税且税率为0
                if ($scope.isTaxClassLocked) {
                    $scope.goodsInfoForm.isPrivilege = 1
                    $scope.goodsInfoForm.privilegeType = $scope.taxClassInfo.taxSpecialManageList[0]
                    $scope.goodsInfoForm.taxRate = 0
                    $scope.taxRateOptions = [0]
                } else {
                    getTaxRateOptions().then(setTaxRate)
                }
            })
        }

        // 是否享受优化政策
        $scope.changeIsPrivilege = function changeIsPrivilege() {
            if ($scope.goodsInfoForm.isPrivilege == 0) {
                $scope.goodsInfoForm.taxRate = $scope.taxClassInfo.taxRateList[0]
                $scope.goodsInfoForm.privilegeType = ''
            } else {
                $scope.goodsInfoForm.privilegeType = $scope.taxClassInfo.taxSpecialManageList[0]
            }
            getTaxRateOptions().then(setTaxRate)
        }

        // 优惠政策变化
        $scope.changePrivilegeType = function changePrivilegeType() {
            getTaxRateOptions().then(setTaxRate)
        }

        // 规则

        $scope.validateRules = {
            code: [{
                erromsg: '2~32个字符，字母或数字',
                condition(value) {
                    if (value === null || value === undefined) {
                        value = ''
                    }
                    const reg = /^[0-9A-Za-z]{2,32}$/
                    // 规则
                    return $scope.codeIsDisable ? false : !reg.test(value)
                },
            }],
            vehicleType: [{
                erromsg: '最大40个字符20个汉字，字母、数字或汉字',
                condition(value) {
                    const reg = /^[\u4e00-\u9fa50-9A-Za-z]{0,40}$/
                    // 规则
                    return !reg.test(value)
                },
            }],
        }
        const submitHandler = {
            edit() {
                httpRequest.post_updateVehicleGoodInfo($scope.goodsInfoForm, '编辑成功').then(() => {
                    $state.go('outputManage.ovat.goodsInfo.list')
                }, () => {
                    $scope.adding = false
                })
            },
            add() {
                httpRequest.post_addVehicleGood($scope.goodsInfoForm, '新增成功').then(() => {
                    $state.go('outputManage.ovat.goodsInfo.list')
                }, () => {
                    $scope.adding = false
                })
            },
        }
        $scope.adding = false
        // 编辑保存
        $scope.submitgoodsInfoForm = function submitgoodsInfoForm() {
            if ($scope.adding) {
                return
            }
            const ret = formvalidateApi.run()
            if(ret && !$scope.goodsInfoForm.place){
                logger.logError("产地为空，请重新输入")
                return
            }
            $scope.adding = true
            if (ret) {
                if ($scope.isEdit) {
                    submitHandler.edit()
                } else {
                    submitHandler.add()
                }
            } else {
                $scope.adding = false
            }
        }

        // 继续新增初始化
        function addContinueInit() {
            // 初始化表单数据
            $scope.goodsInfoForm = {
                code: null,
                vehicleType: '',
                isPrivilege: '0',
                brandmode: '',
                place: '',
                enterpriseName: '',
                status: 1,
                taxRate: 0,
                taxClassName: '',
                taxMergeCode: '',
                privilegeType: '',
                codeVersions: '',
                typeId: $scope.vehicleTypeList[0].typeId,
            }
            $scope.carTypeObj = {}
            $scope.fieldObj = {}
            $scope.manufacturerNameObj = {}
            $scope.taxClassInfo = {}
        }
        // 继续新增
        $scope.addContinuegoodsInfoForm = function () {
            if ($scope.adding) {
                return
            }
            const ret = formvalidateApi.run()
            if(ret && !$scope.goodsInfoForm.place){
                logger.logError("产地为空，请重新输入")
                return
            }
            $scope.adding = true
            if (ret) {
                httpRequest.post_addVehicleGood($scope.goodsInfoForm, '车辆编码添加成功，请继续添加').then(() => {
                    addContinueInit()
                    $scope.adding = false
                }, () => {
                    $scope.adding = false
                })
            } else {
                $scope.adding = false
            }
        }
        // 返回
        $scope.cancelgoodsInfoForm = function () {
            $state.go('outputManage.ovat.goodsInfo.list')
            return false
        }
        $scope.$watch('carTypeObj.name', () => {
            $scope.goodsInfoForm.vehicleType = $scope.carTypeObj.name || ''
        })
        $scope.$watch('fieldObj.name', () => {
            $scope.goodsInfoForm.place = $scope.fieldObj.name || ''
        })
        $scope.$watch('manufacturerNameObj.name', () => {
            $scope.goodsInfoForm.enterpriseName = $scope.manufacturerNameObj.name || ''
        })
    }
}
carEditCtrl.$inject = ['$scope', '$http', 'httpRequest', '$state', 'formvalidateApi', '$timeout','logger']
export default carEditCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsInfo/carEditCtrl.js